import serviceOverview from './service-overview.js';
import './service-overview.scss';

export default serviceOverview;